var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.687,
    height: 27.897,
    viewBox: "0 0 21.687 27.897",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "person",
    transform: "translate(-362.105 -215.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6376",
    "data-name": "Path 6376",
    d: "M374.518,231.888l-1.547,1.525-1.569-1.525",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6377",
    "data-name": "Path 6377",
    d: "M372.2,232.64l-1.547,7.691,2.321,2.321",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6378",
    "data-name": "Path 6378",
    d: "M373.745,232.64l1.525,7.691-2.3,2.321",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6379",
    "data-name": "Path 6379",
    d: "M377.236,239.137l6.145-1.281-.818-4.067a3.939,3.939,0,0,0-1.37-2.3,3.082,3.082,0,0,0-1.349-.707l-3.47-1.016c-.066-.023-.154-.067-.22-.089a.763.763,0,0,1-.332-.53l-.155-1.37a5.807,5.807,0,0,0,2.033-3.205c.619-.044,1.106-.752,1.106-1.613a1.545,1.545,0,0,0-.951-1.592",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6380",
    "data-name": "Path 6380",
    d: "M368.042,221.368a1.58,1.58,0,0,0-.928,1.592,1.479,1.479,0,0,0,1.083,1.613,5.934,5.934,0,0,0,2.033,3.2l-.154,1.371a.724.724,0,0,1-.332.53.678.678,0,0,1-.221.089l-3.47.994a3.084,3.084,0,0,0-1.348.707,4.007,4.007,0,0,0-1.37,2.3l-.818,4.066,5.5,1.15",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6381",
    "data-name": "Path 6381",
    d: "M377.855,221.346s.288-5.746-4.884-5.746-4.906,5.768-4.906,5.768",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6382",
    "data-name": "Path 6382",
    d: "M368.418,218.893a1.819,1.819,0,0,1,1.017-.884,2.88,2.88,0,0,1,2.166.265,9.815,9.815,0,0,0,2.939,1.1,4.991,4.991,0,0,0,2.94-.486",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2290",
    "data-name": "Rectangle 2290",
    width: 2.741,
    height: 1.768,
    rx: 0.287,
    transform: "translate(369.302 221.147)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2291",
    "data-name": "Rectangle 2291",
    width: 2.741,
    height: 1.768,
    rx: 0.287,
    transform: "translate(373.877 221.147)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2539",
    "data-name": "Line 2539",
    x2: 1.834,
    transform: "translate(372.042 221.81)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2540",
    "data-name": "Line 2540",
    x2: 1.26,
    y2: 0.553,
    transform: "translate(368.042 221.169)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2541",
    "data-name": "Line 2541",
    y1: 0.553,
    x2: 1.238,
    transform: "translate(376.618 221.169)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6383",
    "data-name": "Path 6383",
    d: "M375.8,228.816l-2.829,2.542-2.851-2.542",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2542",
    "data-name": "Line 2542",
    y1: 0.597,
    x2: 3.205,
    transform: "translate(377.479 235.027)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.034f07ae73c2aa3be3befab105914f8a.svg";
export { ForwardRef as ReactComponent };